import React from "react";
import { Button, Tooltip } from "antd";
import { DownloadOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { useExportLevelBReport } from "../../hooks/levelb-reports/useExportLevelDReport";
import { LevelBReportFilter } from "../../types/levelb-reports";

interface LevelBExportButtonProps {
  filter: LevelBReportFilter;
}

export const LevelBExportButton: React.FC<LevelBExportButtonProps> = ({ filter }) => {
  const { t } = useTranslation();
  const { exportToExcel, isExporting } = useExportLevelBReport();

  return (
    <Tooltip title={t("levelBReports.export.tooltip")}>
      <Button
        type="primary"
        icon={<DownloadOutlined />}
        loading={isExporting}
        onClick={() => exportToExcel(filter)}
      >
        {t("levelBReports.export.button")}
      </Button>
    </Tooltip>
  );
};

